import { IExplorableItemTypeInfo, IIdItemInfo, IScheduledItemInfo, ISiteItemInfo } from '../../spacesPlatform/models/resourceInfoParts';
import { IUserInfo } from '../../userManagement/users/models/IUserInfo';
import { PageOrientationServerString,PdfPageSizeServerString } from '../components/SubscriptionChangeFormatDialog';
import { CreatorUserStatus } from '../serverApi/types/SubscriptionCreatorUserStatus';

export let SubscriptionTargetTypes = {
  flow: 'flow',
  view: 'view',
  workbook: 'workbook'
};

export interface ISubscriptionInfo extends IIdItemInfo, IScheduledItemInfo, ISiteItemInfo, IExplorableItemTypeInfo<'subscription'> {
  subject: string;
  user: IUserInfo;
  lastSentAt?: Date;
  runNextAt?: Date;

  canSpecifyDataCondition: boolean;
  dataConditionPresent: boolean;

  targetId: string;
  targetName: string;
  targetType: string;
  targetPath: string;
  creator: IUserInfo;
  canManageSubscription: boolean;

  lastRunError?: string;
  failed?: boolean;
  suspended?: boolean;

  attachImage?: boolean;
  attachPdf?: boolean;

  pageSizeOption?: PdfPageSizeServerString;
  pageOrientation?: PageOrientationServerString;

  refreshExtractTriggered?: boolean;

  creatorUserStatus: CreatorUserStatus;
}
